import { Component, ViewEncapsulation } from "@angular/core";

@Component({
    selector: "roblex-modal-content",
    templateUrl: "./modal-content.component.html",
    styleUrls: ["./modal-content.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class ModalContentComponent {
    constructor() {}
}
